'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PopoverInner = _styledComponents2.default.div(_templateObject);

var PopoverBase = function PopoverBase(props) {
  return _react2.default.createElement(
    'div',
    props,
    _react2.default.createElement(
      PopoverInner,
      null,
      props.children
    )
  );
};

exports.default = PopoverBase;